


























import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { InitModule } from '@/store/modules/init'
import { list, authorityAdd, authorityUpdate, authorityDetails } from '@/api/authority'
import { ListResponse, DetailsResponse } from '../index.d'

@Component({
  name: 'RoleOperationModal'
})
export default class extends Vue {
  @Prop({ default: false }) operationDialogFlag!: boolean
  @Prop() id!: number
  private visible = false
  private formParams = {
    name: '',
    remark: '',
    appId: '',
    authorityGroupId: ''
  }

  private groupList: ListResponse[] = []

  get appList() {
    return InitModule.appList
  }

  private rules = {
    name: [{ required: true, message: '请输入权限名', trigger: 'change' }],
    appId: [{ required: true, message: '请选择平台', trigger: 'change' }],
    authorityGroupId: [{ required: true, message: '请选择权限组', trigger: 'change' }]
  }

  // 选择平台查询权限组
  private async change() {
    const { content } = await list<ListResponse[]>({ appId: this.formParams.appId })
    this.groupList = content
    if (this.groupList.length === 0) {
      this.formParams.authorityGroupId = ''
    }
  }

  private close() {
    this.$emit('update:operationDialogFlag', false);
    (this.$refs.form as ElForm).resetFields()
  }

  private onSubmit() {
    (this.$refs.form as ElForm).validate(async(valid: boolean) => {
      if (valid) {
        this.id ? await authorityUpdate({ ...this.formParams, id: this.id }) : await authorityAdd(this.formParams)
        this.id ? this.$message.success('修改成功') : this.$message.success('新增成功')
        this.$emit('onsubmit')
        this.close()
      }
    })
  }

  @Watch('operationDialogFlag')
  async handQualityDialogFlag() {
    this.visible = this.operationDialogFlag
    if (this.visible && this.id) {
      // 数据回填
      const { content } = await authorityDetails<DetailsResponse>({ id: this.id })
      const { name, authorityGroupId, remark, appId } = content
      this.formParams = { name, remark, appId, authorityGroupId }
      await this.change()
    }
  }
}
